<template>
	<div id="busybox" class="text-center text-primary my-2">
		<b-spinner class="align-middle mr-3"></b-spinner>
		<strong>Cargando...</strong>
	</div>
</template>

<script>
export default {};
</script>

<style></style>
